import { connect } from 'react-redux';

import { selectFlags } from 'modules/user';

export default (WrappedComponent) =>
  connect((state) => ({ flags: selectFlags(state) }))(WrappedComponent);
